<div class="verification-modal tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-1 tw-pt-1 tw-text-center">
  <div
    class="verification-modal__hero tw-flex tw-h-[5.5rem] tw-w-[5.5rem] tw-items-center tw-justify-center tw-rounded-full tw-bg-[rgb(var(--bg-detail-container))]"
    aria-hidden="true"
  >
    <i
      class="verification-modal__icon ic-duotone tw-text-[2.75rem] tw-leading-none tw-text-[rgb(var(--text-accent-primary,var(--text-primary)))]"
      [ngClass]="
        isPending
          ? 'ic-design-clock-circle'
          : 'ic-security-shield-warning'
      "
    ></i>
  </div>

  <header class="verification-modal__header tw-flex tw-flex-col tw-items-center">
    <h5 class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">
      {{
        isPending
          ? 'اطلاعات شما با موفقیت ثبت شد'
          : 'تکمیل حساب کاربری و احراز هویت'
      }}
    </h5>
    <p
      class="tw-m-0 tw-mt-2 tw-max-w-md tw-text-center smsir-helper-lg tw-text-[rgb(var(--text-secondary))] tw-whitespace-pre-wrap"
    >
      {{
        isPending
          ? 'درخواست احراز هویت شما در حال بررسی است و نتیجه فعال‌سازی به‌زودی از طریق پیامک اعلام می‌شود.'
          : 'برای استفاده کامل از تمام امکانات پنل نیاز به تایید هویت شما هست.'
      }}
    </p>
  </header>

  <div
    class="verification-modal__actions tw-mt-2 tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-end tw-gap-2"
  >
    <button
      type="button"
      smsir-button
      [variant]="isPending ? 'tertiary-colored' : 'text'"
      size="sm"
      class="verification-modal__action-btn tw-min-w-0 tw-flex-auto md:tw-min-w-[8.5rem] md:tw-flex-none"
      (click)="onCancel()"
    >
      {{ isPending ? 'متوجه شدم' : 'بعدا انجام می‌دهم' }}
    </button>

    <button
      *ngIf="!isPending"
      type="button"
      smsir-button
      httpLoading
      variant="secondary"
      size="sm"
      class="verification-modal__action-btn tw-min-w-0 tw-flex-auto md:tw-min-w-[8.5rem] md:tw-flex-none"
      (click)="onSubmit()"
    >
      احراز هویت
    </button>
  </div>
</div>
